import DocPreLogService, { checkAllDocsIncluded, DocPreLogs } from '../../services/DocPreLogService';
import moment from "moment";
import styles from './index.module.sass';
import { useEffect, useState } from 'react';
import { DetailsList, SelectionMode, Spinner, SpinnerSize } from '@fluentui/react';
import { PortfolioModelFundsDocumentsType } from '../../services/PortfolioModelService';

const columns: any =
[
    { key: 'name', name: 'Fichero', fieldName: 'name', minWidth: 75, maxWidth: 75 },
    { key: 'link', name: 'Acción', fieldName: 'url', minWidth: 90, maxWidth: 90 },
    { key: 'dateClick', name: 'Fecha de lectura', fieldName: 'dateClick', minWidth: 150 }
];

interface Props
{
    data: PortfolioModelFundsDocumentsType[],
    user: any
    allDocumentsReaded: boolean,
    setAllDocumentsReaded: (allDocumentsReaded: boolean) => void
}

const Documents = (props: Props) =>
{
    const {data, user, allDocumentsReaded, setAllDocumentsReaded} = props;
    const [docPreLogs, setDocPreLogs] = useState<DocPreLogs[]>();
    const [loadingDocPreLogs, setLoadingDocPreLogs] = useState<boolean>(true);
    const [cartIsins, setCartIsins] = useState<string[]>([]);

    useEffect(() =>
    {
        const newIsins = data.map(cL => cL.isin);

        const longArray = newIsins.length > cartIsins.length ? newIsins : cartIsins;
        const shortArray = newIsins.length > cartIsins.length ? cartIsins : newIsins;

        const differenceIsins = longArray.filter(isin => !shortArray.includes(isin));

        if(differenceIsins.length > 0)
        {
            setCartIsins(newIsins);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() =>
    {
        if(cartIsins.length > 0)
        {
            setLoadingDocPreLogs(true);
            DocPreLogService.docPreLogsByUserId(user.id, cartIsins).then((response: DocPreLogs[]) =>
            {
                setDocPreLogs(response);
                setTimeout(() => setLoadingDocPreLogs(false), 100);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartIsins]);

    useEffect(() =>
    {
        if(data.length > 0 && docPreLogs !== undefined)
        {
            const notAllDocumentsReaded = data.some((cL: any) =>
            {
                var docPreLogsTypesByIsin = docPreLogs.filter((dPL: DocPreLogs) => dPL.isin === cL.isin).map((dPL: any) => dPL.documentType);
                var docsIncluded = checkAllDocsIncluded(cL.isin, cL.documents);
                return !docsIncluded.result || docsIncluded.documents.some((d: any) => !docPreLogsTypesByIsin.includes(d.type));
            });
            setAllDocumentsReaded(!notAllDocumentsReaded);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docPreLogs]);

    const onDocumentClick = (isin: string, document: any) =>
    {
        DocPreLogService.createDocPreLogs(
        {
            userId: user.id,
            isin: isin,
            documentType: document.type,
            dateClick: moment().toISOString()
        })
        .then((response: DocPreLogs) =>
        {
            setDocPreLogs(prevAux => [...(prevAux ?? []), response]);
        });
    };

    const renderAttachmentColumn = (isin: string, item: any, index: any, column: any) =>
    {
        switch(column.key)
        {
            case 'name':
                if(docPreLogs === undefined)
                {
                    return <></>
                }
                var docPrelog = docPreLogs.find(dPL => dPL.isin === isin && dPL.documentType === item.type);
                if(docPrelog)
                {
                    return <span style={{textWrap: 'wrap'}}>{item.name}</span>
                }
                return <span style={{textWrap: 'wrap'}}>{item.name}</span>

            case 'link':
                return <a href={item.url} target="_blank" rel="noreferrer" onClick={() => onDocumentClick(isin, item)}>
                            <i className={'ironia-icon downloads'} /> Descarga
                        </a>;

            case 'dateClick':
                if(docPreLogs === undefined)
                {
                    return <></>
                }
                var docPrelogDateClick = docPreLogs.find(dPL => dPL.isin === isin && dPL.documentType === item.type);
                if(docPrelogDateClick)
                {
                    return <div className={styles.withDate}>
                        <i className="ironia-icon circledCheck" />
                        <span>{moment(docPrelogDateClick.dateClick).format("DD/MM/YYYY hh:mm")}</span>
                    </div>
                }

                return <div className={styles.withoutDate}>
                    <i className={`ironia-icon cross primaryColor ${styles.cross}`} />
                    <span style={{textWrap: 'wrap'}}>Pulse sobre el enlace de descarga para leer el documento</span>
                </div>

            default:
                return item[column.fieldName];
        }
    }

    if (loadingDocPreLogs)
    {
        return null
    }

    return(
        <div className={styles.documents}>
            {loadingDocPreLogs && <Spinner size={SpinnerSize.small} />}
            {!loadingDocPreLogs && data.length > 0 &&
            (
                <div className="ms-Grid-row">
                    {data.map((dataItem) => {
                        const allDocsReaded = checkAllDocsIncluded(dataItem.isin, dataItem.documents);
                        return (
                            <div key={dataItem.isin}>
                                <div className={`ms-Grid-col ms-lg12 ms-xl6 ms-xxl4 ms-xxxl3 p10 ${styles.listContainer}`}>
                                    <h4>Documentos del fondo {dataItem.isin}</h4>
                                    {!allDocsReaded.result
                                        ?   <p className={`shadow ${styles.noDocuments}`}>
                                                <i className={`ironia-icon cross inlineBlock ${styles.cross}`} />
                                                <span>No hay documentación disponible para este fondo por lo que no puede continuar con la suscripción del mismo.</span>
                                            </p>
                                        :   <DetailsList
                                                setKey="items"
                                                items={allDocsReaded.documents}
                                                columns={columns}
                                                onRenderItemColumn={(row, index, column) => renderAttachmentColumn(dataItem.isin, row, index, column)}
                                                selectionMode={SelectionMode.none}
                                            />
                                    }
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Documents;